import DocumentForm from './DocumentForm';

export default DocumentForm;